import { render, staticRenderFns } from "./page-header.vue?vue&type=template&id=96d6f7aa&"
import script from "./page-header.vue?vue&type=script&lang=js&"
export * from "./page-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96d6f7aa')) {
      api.createRecord('96d6f7aa', component.options)
    } else {
      api.reload('96d6f7aa', component.options)
    }
    module.hot.accept("./page-header.vue?vue&type=template&id=96d6f7aa&", function () {
      api.rerender('96d6f7aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page-header.vue"
export default component.exports